import { useState } from 'react';
import CommonTable from '../../../global/table';
import CommonCardView from '../../../global/cardView';
import NoRecordFound from '../../../global/noRecordFound';
import CommonDrawer from '../../../global/drawer';
import EnhancedAutoresponseSentDetails from './EnhancedAutoresponseSentDetails';
import { formatDateTime } from '../../../../utils/functions';
import EnhancedAutoresponseSentCardView from './EnhancedAutoresponseSentCardView';

const EnhancedAutoresponseSentList = ({
    isLoading,
    data,
    sort,
    setSort,
    viewType
}) => {
    const [detailState, setDetailState] = useState({
        show: false,
        id: null
    });

    const columns = [
        {
            title: "Send Date",
            dataIndex: "dateAsPerUserTimezone",
            key: "dateAsPerUserTimezone",
            sortType: "dateAsPerUserTimezone",
            render: (text) => formatDateTime(text)
        },
        {
            title: "Total Sent (Leads)",
            dataIndex: "leadSent",
            key: "leadSent",
            sortType: "leadSent",
            render: (leadSent) => Array.isArray(leadSent) ? leadSent.length : 0
        }
    ];

    const openDetails = (record) => {
        setDetailState({ show: true, id: record._id });
    };

    return (
        <>
            {data && data.length > 0 ? (
                <>
                    {viewType === "LIST" ? (
                        <CommonTable
                            columns={columns}
                            data={data}
                            sort={sort}
                            setSort={setSort}
                            onRowClick={openDetails}
                        />
                    ) : (
                        <CommonCardView>
                            {data.map((record) => (
                                <EnhancedAutoresponseSentCardView
                                    key={record._id}
                                    record={record}
                                    onCardClick={openDetails}
                                />
                            ))}
                        </CommonCardView>
                    )}
                </>
            ) : (
                <NoRecordFound message="No autoresponses found." />
            )}

            {detailState.show && (
                <CommonDrawer
                    open={detailState.show}
                    setOpen={() => setDetailState({ show: false, id: null })}
                    title="Autoresponse Details"
                    width={"800px"}
                    children={
                        <EnhancedAutoresponseSentDetails
                            id={detailState.id}
                        />
                    }
                />
            )}
        </>
    );
};

export default EnhancedAutoresponseSentList;
